module.exports = __webpack_public_path__ + "media/download.1e40b43d.svg";